import React, { FC, useState } from "react";
import { AnalyticsQuerySet, Product } from "../../../models/types";
import { useLocalAnalyticsState } from "../../../graphql/hooks";
import { Col, Collapse, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import { AnalyticsFunnelViewSelectionToggle } from "../../buttons/analytics/AnalyticsFunnelViewSelectionToggle";
import { AnalyticsProjects } from "../../modals/analytics/AnalyticsProjects";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { AnalyticsFunnelViewComparisonToggle } from "../../buttons/analytics/AnalyticsFunnelViewComparisonToggle";
import { getTree } from "../../../common/AnalyticsHelpers";
import { DailyBadges } from "./DailyBadges";
import { UserQueryBadges } from "./UserQueryBadges";
import styles from "./FunnelBatchBuild.module.scss";

interface Props {
    product: Product;
}

const FunnelProductImplementation: FC<Props> = ({ product }) => {
    const analyticsState = useLocalAnalyticsState();
    const myTree: AnalyticsQuerySet | undefined = getTree(
        analyticsState,
        Number(product.id),
        "products"
    );
    const [show, setShow] = useState(
        (myTree?.selection?.projects && myTree.selection.projects.length > 0) ||
            false
    );

    return (
        <div className={styles.container}>
            <Row className="d-flex align-items-center my-1 g-0">
                <Col
                    className={`${styles.selectionToggleCol} d-flex align-items-center`}
                >
                    <AnalyticsFunnelViewSelectionToggle
                        reference="product"
                        product={product}
                    />
                    <OverlayTrigger
                        placement="top"
                        delay={{ show: 550, hide: 100 }}
                        overlay={
                            <Tooltip id="funnel-product-tooltip">
                                Product name
                            </Tooltip>
                        }
                    >
                        <span
                            onClick={() => setShow(!show)}
                            className="ps-3 mouseHover medium-font"
                        >
                            {product.name}
                        </span>
                    </OverlayTrigger>
                    <AnalyticsFunnelViewComparisonToggle
                        reference="product"
                        className="ms-2"
                        product={product}
                    />
                    <FontAwesomeIcon
                        onClick={() => setShow(!show)}
                        className="mx-2 mouseHover color-secondary"
                        icon={show ? faChevronUp : faChevronDown}
                        size="xs"
                    />
                </Col>
                <Col className={styles.analyticsCol}>
                    <DailyBadges reference="product" referenceId={product.id} />
                </Col>
                <Col className={styles.analyticsCol}>
                    <UserQueryBadges
                        reference="product"
                        referenceId={product.id}
                    />
                </Col>
                <Col className={styles.infoIconCol}></Col>
            </Row>
            <Collapse in={show}>
                <div>
                    <AnalyticsProjects
                        product={product}
                        show={show}
                        collapseTree={myTree}
                    />
                </div>
            </Collapse>
        </div>
    );
};

export const FunnelProduct = React.memo(FunnelProductImplementation);
